import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ProfileDocumentsDataTable from './ProfileDocumentsDataTable';
import { indexRiskPreventionDocumentRequest } from '../../../requests/riskPreventionDocuments';

const RiskPreventionProfileIndex = () => {
  const allowedDocumentTypes = [
    'order_hygiene_safety',
    'labor_direction',
    'emergency_evaluation',
    'riohs_labor_inspection',
    'riohs_seremi'
  ];

  const filterFunction = data => {
    return data.filter(item => item.document_type === null || allowedDocumentTypes.includes(item.document_type));
  };

  return (
    <>
      <Row className="mt-4 mb-4">
        <Col>
          <h2 className="mb-3 mt-3">Documentación Legal</h2>
        </Col>
      </Row>

      <ProfileDocumentsDataTable
        endpointIndex={indexRiskPreventionDocumentRequest}
        preName="risk_prevention_documents"
        filterFunction={filterFunction}
        sortByDocumentType
      />
    </>
  );
};

export default RiskPreventionProfileIndex;
